// @flow

import PaymentAccountBalanceFormPaneField from './form/PaymentAccountBalanceFormPaneField';

export const components = {
    'floatPaneField:paymentAccountBalance': PaymentAccountBalanceFormPaneField,
}

